import styled, { css } from '@xstyled/styled-components'

export const ProductImagesWrapper = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 120px 1fr;
  column-gap: 2;
  align-items: center;
  max-width: 880px;
  justify-items: center;
  @media screen and (max-width: 1024px) {
    column-gap: 2;
    grid-template-columns: 1fr;
    max-width: 100%;
    margin-bottom: 5;
  }
  @media screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const ProductImagesThumbnails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  & > * + * {
    margin-top: 2;
  }
  @media screen and (max-width: 640px) {
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    order: 1;
    & > * {
      max-width: 90px;
    }
    & > * + * {
      margin-top: 0;
    }
  }
`

export const ProductImagesCurrentImage = styled.div``
